<template>
  <div v-if="loading || posts.length" class="card">
    <div class="card-body py-1 table-responsive-sm">
      <table class="table table-sm mb-0">
        <thead>
          <tr>
            <th class="border-top-0">Interactions</th>
            <th class="border-top-0 text-center">Text</th>
            <th></th>
            <th class="border-top-0">Posting Time</th>
          </tr>
        </thead>
        <tbody v-if="!loading">
          <tr v-for="post in posts" v-bind:key="post.id">
            <td class="text-center align-middle">{{ post.total_reactions_count }}</td>
            <td>
              <a
                v-if="post.truth_id"
                class="mb-0"
                style="white-space: pre-line;"
                :href="post.route"
              >{{ post.text }}</a>
              <p v-else class="mb-0" style="white-space: pre-line;">{{ post.text }}</p>
            </td>
            <td class="align-middle">
              <a :href="post.fb_link">
                <i class="fab fa-2x fa-facebook-square"></i>
              </a>
            </td>
            <td class="text-center align-middle">{{ post.timePostedTZ }}</td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="4" class="text-center">
              <i class="fa fa-spinner fa-pulse fa-fw"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "TopPostsCard",

  props: {
    timescale: {
      type: String,
      Default: "Today"
    }
  },

  data() {
    return {
      loading: true,
      posts: []
    };
  },

  created() {
    this.loadTopPosts();
  },

  methods: {
    loadTopPosts() {
      this.loading = true;
      var self = this;
      axios
        .get("api/posts/top", {
          params: {
            timescale: this.timescale
          }
        })
        .then(function(response) {
          self.loading = false;
          // convert to an array (so we can easily get the length)
          self.posts = response.data;
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>